import { useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

/**
 * Hook personnalisé pour surveiller le statut d'archivage de l'utilisateur connecté
 * Déconnecte automatiquement l'utilisateur s'il est archivé
 */
const useArchiveMonitor = () => {
  const [user] = useAuthState(auth);

  useEffect(() => {
    if (!user) return;

    const checkArchiveStatus = async () => {
      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists() && userDoc.data().isArchived) {
          console.log('Utilisateur archivé détecté, déconnexion...');
          await auth.signOut();
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du statut d\'archivage:', error);
      }
    };

    // Vérifier immédiatement
    checkArchiveStatus();

    // Vérifier périodiquement toutes les 30 secondes
    const interval = setInterval(checkArchiveStatus, 30000);

    return () => clearInterval(interval);
  }, [user]);
};

export default useArchiveMonitor;
